import { Reveal } from "@/components/site/Reveal";
import { ChatCircleText, ShieldCheck, MapPinLine, CalendarCheck, BookOpen } from "@phosphor-icons/react";

const values = [
  { icon: ChatCircleText, title: "Clear Information", desc: "Conditions and options explained in plain, understandable language." },
  { icon: ShieldCheck, title: "Professional Presentation", desc: "A considered, trustworthy and transparent professional profile." },
  { icon: MapPinLine, title: "Easy Access to Clinic Information", desc: "Clinic and contact details presented clearly and openly." },
  { icon: CalendarCheck, title: "Transparent Appointment Process", desc: "A straightforward, honest path to requesting a consultation." },
  { icon: BookOpen, title: "Patient Education", desc: "Helpful, general health information to support informed decisions." },
];

export function ValueTrust() {
  return (
    <section className="relative py-24 md:py-32 bg-[#0A192F] text-white overflow-hidden grain">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <Reveal className="max-w-3xl">
          <span className="label text-white/50">Trust</span>
          <h2 className="font-display text-4xl sm:text-6xl tracking-tight leading-[1.05] mt-4">
            Why Patients Value Clear Medical Communication
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-12" data-testid="value-trust-grid">
          {values.map((v, i) => (
            <Reveal key={v.title} delay={(i % 3) * 0.08}>
              <div className="border-t border-white/15 pt-6">
                <v.icon size={32} weight="duotone" className="text-white/90" />
                <h3 className="font-display text-2xl mt-4">{v.title}</h3>
                <p className="mt-2 text-white/60 leading-relaxed">{v.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-14 text-xs text-white/40 italic font-mono max-w-2xl">
            Testimonials are not shown. Verified patient testimonials can be added later through the admin panel.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
